import TerminalAPI from '@/features/api/terminal/terminal'
import { logger } from '@/features/orders/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { CancelOrderReason } from '@/types/cancelOrder'
import { useRef, useState } from 'react'

interface UseCancelOrderDialogSubmissionOptions {
    uuid: string
    reason: CancelOrderReason
    returnMoney: boolean
    confirmedNote: string | null
    onDismiss: () => void
    onNoteButtonPress: () => void
}

export const useCancelOrderDialogSubmission = ({
    uuid,
    reason,
    returnMoney,
    confirmedNote,
    onDismiss,
    onNoteButtonPress,
}: UseCancelOrderDialogSubmissionOptions) => {
    const [loading, setLoading] = useState(false)
    const inFlight = useRef(false)
    const handleError = useHandleErrorWithToast(logger)

    const handleConfirm = async () => {
        if (inFlight.current) return

        inFlight.current = true
        setLoading(true)

        try {
            await TerminalAPI.cancelOrder(uuid, reason, returnMoney, confirmedNote ?? undefined)

            onDismiss()
        } catch (e) {
            handleError(e)
        } finally {
            inFlight.current = false
            setLoading(false)
        }
    }

    const handleDismiss = () => {
        if (!inFlight.current) onDismiss()
    }

    const handleNoteButtonPress = () => {
        if (!inFlight.current) onNoteButtonPress()
    }

    return { loading, handleConfirm, handleDismiss, handleNoteButtonPress }
}
